import React, { useState } from 'react';
import { Box, Icon } from '@chakra-ui/react';
import { FloatingInputField } from '@payler/ui-components';
import { CloseEyesIcon, OpenEyesIcon } from '@payler/ui-icons';

type Props = {
  name: string;
  label: string;
};

export const PaymentPasswordField = ({ name, label }: Props) => {
  const [visible, setVisible] = useState(false);

  return (
    <Box position="relative" w="full">
      <FloatingInputField
        name={name}
        label={label}
        type={visible ? 'text' : 'password'}
        autoComplete="new-password"
        pr="40px"
      />
      <Box
        position="absolute"
        right="8px"
        top={0}
        h={7}
        zIndex={1}
        pointerEvents="auto"
        display="flex"
        alignItems="center"
      >
        <Icon
          as={visible ? OpenEyesIcon : CloseEyesIcon}
          w="20px"
          h="20px"
          color="primary.300"
          cursor="pointer"
          onClick={() => setVisible((value) => !value)}
        />
      </Box>
    </Box>
  );
};
